import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  secondary: PropTypes.bool,
};

// eslint-disable-next-line react/function-component-definition
export default function Logo({ sx, secondary = false }) {
  return secondary ? (
    <Box
      component="img"
      src="/assets/logo-secondary.svg"
      sx={{ width: 80, color: '#00466F', ...sx }}
    />
  ) : (
    <Box component="img" src="/assets/logo.svg" sx={{ width: 80, color: '#00466F', ...sx }} />
  );
}
